import { GetRouteGroupItemsQueryDto, RouteGroupItem } from '@ekt-group/general-purpose-api-interfaces';

import { useFetch } from '@/lib/react-query';
import { apiRoutes } from '@/utils/routes';

export const useGetRouteGroupItems = (params: GetRouteGroupItemsQueryDto) =>
  useFetch<RouteGroupItem[]>(apiRoutes.getRouteGroupItems, params);
